import { Row } from "antd";
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import {
  NavLink,
  Extra,
  LogoContainer,
  Language,
} from "./styles";

const Footer = ({ t }: any) => {
  return (
    <>
      <Extra>
        <Container border={true}>
          <Row
            justify="space-between"
            align="middle"
            style={{ paddingTop: "3rem" }}
          >
            <NavLink to="/">
              <LogoContainer>
                <SvgIcon
                  src="logo.svg"
                  aria-label="homepage"
                  width="301px"
                  height="120px"
                />
              </LogoContainer>
            </NavLink>
            <>
            <div style={{minWidth: "100px"}}>
              <Language>{t("Daglig leder")}</Language>
              <p>Tlf +47 406 23 576</p>
              <p>E-post: D.saalsajev@hotmail.com</p>
            </div>
            </>
            <>
            <div style={{minWidth: "100px"}}>
              <Language>{t("Flytteansvarlig")}</Language>
              <p>Tlf +47 981 67 962</p>
              <p>E-post: M.saalsajev@hotmail.com</p>
            </div>
            </>
          </Row>
        </Container>
      </Extra>
    </>
  );
};

export default withTranslation()(Footer);
